import { FaReact, FaHtml5, FaAngular, FaJs } from "react-icons/fa";
import { SiNextdotjs } from "react-icons/si";

import article from "../Assets/article.jpg";
import btn from "../Assets/btn.png";
import citizenp from "../Assets/citizenp.png";
import clerk from "../Assets/clerk.png";
import dslms from "../Assets/dslms.png";
import expense from "../Assets/expense.png";
import facility from "../Assets/facility.png";
import mipad from "../Assets/mipad.png";
import polleasy from "../Assets/polleasy.png";
import proworks from "../Assets/proworks.png";
import stanbicupl from "../Assets/stanbicupl.png";
import mpi from "../Assets/mpi.png";

const projects = [
  {
    id: "1",
    name: "Expense Tracker",
    description: "Expense Tracker with Speechly",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://speechly-exp-tracker.netlify.app",
    pic: expense,
    lang: "React",
    github: "https://github.com/hebraheem/expense-tracker-with-speechly",
  },
  {
    id: "16",
    name: "CSS Animation",
    description: "CSS button animation",
    icon: <FaHtml5 style={{ fontSize: "100%" }} />,
    link: "https://buttonanimation.netlify.app/",
    pic: btn,
    lang: "HTML",
    github: "https://github.com/hebraheem/neon-button-animation",
  },
  {
    id: "2",
    name: "Learning Management Solution",
    description: "Learning Management Solution for Delta State Nigeria",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "http://dslms.ng/",
    pic: dslms,
    lang: "React",
  },
  {
    id: "3",
    name: "MIPAD",
    description: "Event registration and tracking platform for MIPAD",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://events.mipad.org/events",
    pic: mipad,
    lang: "React",
  },
  {
    id: "4",
    name: "Estate Management Solution",
    description: "Estate Management solution",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://demoestate.facilitybills.com/",
    pic: facility,
    lang: "React",
  },
  {
    id: "5",
    name: "Loan App",
    description: "Loan App for Stanbic IBTC",
    icon: <FaAngular style={{ fontSize: "100%" }} />,
    link: "https://ezcash.stanbicibtc.com/EZCash9-5",
    pic: stanbicupl,
    lang: "Angular",
  },
  {
    id: "6",
    name: "Citizen Management",
    description: "Citizen Management for OYO state",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://oyo-citizen-dev.netlify.app/",
    pic: citizenp,
    lang: "React",
  },
  {
    id: "7",
    name: "RMS",
    description: "Remote monitoring system (starsight)",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "",
    pic: article,
    lang: "React",
  },
  {
    id: "8",
    name: "Proworks",
    description: "Business Processing Automation System for OYO State",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://proworks-oyo.vercel.app/",
    pic: proworks,
    lang: "React",
  },
  {
    id: "9",
    name: "PollEasy",
    description:
      "A platform that helps to collect data and layer analytics to manage election.",
    icon: <FaReact style={{ fontSize: "100%" }} />,
    link: "https://polleasy.netlify.app/",
    pic: polleasy,
    lang: "React",
  },
  {
    id: "10",
    name: "Tech11 insurance",
    description:
      "T11 insurance platform is used for insurance management written in web component",
    icon: <FaJs style={{ fontSize: "100%" }} />,
    link: "https://dev-03.tech11.com/clerk-ui/",
    pic: clerk,
    lang: "Web Component (js)",
  },
  {
    id: "12",
    name: "Nigeria Poverty Index(NPI)",
    description:
      "Analysis of multidimensional poverty in Nigeria, including its composition and disaggregation across states and districts",
    icon: <SiNextdotjs style={{ fontSize: "100%" }} />,
    link: "https://www.nigeriapovertymap.com/",
    pic: mpi,
    lang: "NextJs",
  },
];

export default projects;
